import React from 'react';
import { Tabs } from 'antd';
import { AcvtSupportedLanguages } from '../../../types/acvt';
import { TabType } from '../../top-tabs';

interface TabsAcvt {
    name: React.ReactNode;
    key: string;
    children?: React.ReactNode;
}

interface TabsProps {
    tabsArray: TabsAcvt[];
    tabType?: TabType;
    tabChangeLanguage?: (lang: AcvtSupportedLanguages) => void;
}

export const AcvtTopTabs = ({
    tabsArray,
    tabType,
    tabChangeLanguage,
}: TabsProps) => {
    const handleTabClick = (activeKey: string) => {
        if (tabChangeLanguage) {
            tabChangeLanguage(activeKey as AcvtSupportedLanguages);
        }
    };

    const items = tabsArray?.map((tab) => ({
        key: tab.key,
        label: tab.name,
        children: tab.children,
    }));

    return <Tabs type={tabType} onTabClick={handleTabClick} items={items} />;
};
